/* global window */
/* eslint-disable no-console */

require('isomorphic-unfetch');
const _fetchRetry = require('fetch-retry');
const URL = require('url-parse');
const hasDom = require('has-dom');
const { getCircuitBreaker } = require('./CircuitBreakerManager.js');

module.exports = async function _fetch(path, { query, search, data, circuitBreaker, base, retries, retryOn, retryDelay, onError, ...options } = {}) {

    // assign localhost as the base if one is not supplied
    if (!base) {
        base = `${process.env.PROTOCOL}://${process.env.HOST}:${process.env.PORT}`;
    }

    // allow for relative client requests
    if (hasDom()) {
        base = window.location.origin;
    }

    const url = new URL(path, base);
    const hasQuery = Boolean(url.query);

    // Build a query string
    if (query || search || data) {
        if (hasQuery) {
            throw Error('bonnet fetch will not append query, search, or data to an existing query string');
        } else {
            // Allow service to supply a querystring via query, search, data options
            url.set('query', {
                ...query,
                ...search,
                ...data,
            });
        }
    }

    const enableRetry = retries || retryOn || retryDelay;

    const fetcher = (...args) => {
        function handleErrors(response) {
            if (!response.ok) {
                console.log(`response from ${url.href} was not ok`, response);
                return Promise.reject(response);
            }

            return response;
        }

        return fetch(...args)
            .then(handleErrors)
            // eslint-disable-next-line consistent-return
            .catch((err) => {
                // err can be a rejected promise with a failed response from handleErrors(above) or network error
                console.error(err);
                if (typeof onError === 'function') {
                    onError(err);
                }
                if (circuitBreaker) {
                    return Promise.reject(err); // throw rejected promise to circuitbreaker to trip
                }
                if (enableRetry) {
                    if (err && err.status) {
                        return err; // resolve failed response to further retry
                    }
                    return Promise.reject(err); // reject network error to further retry
                }
            });
    };

    let fetchBuilder;

    if (circuitBreaker) {
        const breaker = await getCircuitBreaker(fetcher, url, circuitBreaker);

        fetchBuilder = (...args) => breaker.fire(...args)
            .catch((error) => {
                console.log(`Failed breaker call to ${args[0]}`, error);
            });
    } else {
        fetchBuilder = fetcher;
    }

    // wrap with fetch-retry
    // https://github.com/jonbern/fetch-retry
    if (enableRetry) {
        return _fetchRetry(fetchBuilder, {
            ...(retries && { retries }),
            ...(retryOn && { retryOn }),
            ...(retryDelay && { retryDelay }),
        })(url.href, options);
    }

    return fetchBuilder(url.href, options);
};
